export const locale = {
  title: ' Line chart graphs, values in {{title}}:  from {{min}} to {{max}},',
};
